
import {
    RAISE_QUERY_ADMIN_ROLE_RESPONSE, RAISE_QUERY_ADMIN_ROLE_FAILED
} from '../types/addUser';

const initialState = {
    getQueryAdminRole: {},

}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case RAISE_QUERY_ADMIN_ROLE_RESPONSE:
            return { ...state, getQueryAdminRole: action.payload }
        case RAISE_QUERY_ADMIN_ROLE_FAILED:
            return { ...state, getQueryAdminRole: action.payload }

        default:
            return state
    }

}
